<template>
  <div id="app" class="template">
    <headers></headers>
    <router-view/>
    <footers></footers>
  </div>
</template>

<script>
import Footers from './components/footer.vue'
import Headers from './components/header.vue'
export default {
  name: 'App',
  comments:{
    Headers,
    Footers
  },
  methods: {

    },
}
</script>

<style>
html,body,ul,li,p,h1,h2,h3,h4,h5,h6{margin:0;border:0;padding:0;}
ul,li{list-style: none;}
a{text-decoration:none;}

@media screen and (max-width:1440px) {
  body{min-width:1440px;}
  .nav ul li{padding:0 16px!important;}
  .template {
    position: absolute;
    transform: scale(0.8);
    overflow-x: hidden;
    width: 125%;
    height: 125%;
    left: -13%;
    top: -13%;
  }
}
@media screen and (max-width:1280px) {
  body{min-width:1280px;}
  .top p img{margin-right:20px!important;}
  .top p{font-size:32px!important;}
  .nav ul li{padding:0 10px!important;}
  .banner_content .banner{width:1280px!important;}
  .banner .banner_left{width:700px!important;}
  .template {
    position: absolute;
    transform: scale(0.8);
    overflow-x: hidden;
    width: 125%;
    height: 125%;
    left: -13%;
    top: -13%;
  }
}
@media screen and (max-width:1024px) {
  .top p img{margin-right:10px!important;width:44px!important;height:44px!important;margin-top:8px!important;}
  .top p{font-size:30px!important;}
  .nav ul li{font-size:25px!important;}
  .template {
    position: absolute;
    transform: scale(0.8);
    overflow-x: hidden;
    width: 125%;
    height: 125%;
    left: -13%;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue